<template>
  <div class="text-field-wrapper">
    <div class="text-field-area">
      <div class="text-field-holder">
        <div
          class="text-field"
          v-bind:class="{ active: undefined !== value && value.length > 0 }"
        >
          <input
            v-bind:style="[
              isUpper
                ? { 'text-transform': 'uppercase' }
                : { 'text-transform': 'none' },
            ]"
            v-bind:maxlength="maxlength"
            v-bind:min="minvalue"
            v-bind:max="maxvalue"
            v-bind:type="type"
            v-if="mask && type == 'text'"
            v-mask="mask"
            v-bind:value="value"
            v-bind:step="1"
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
            v-on="inputListeners"
          />

          <input
            v-else
            v-bind:style="[
              isUpper
                ? { 'text-transform': 'uppercase' }
                : { 'text-transform': 'none' },
            ]"
            v-bind:maxlength="maxlength"
            v-bind:max="maxvalue"
            v-bind:min="minvalue"
            v-bind:type="type"
            v-bind:value="value"
            v-bind:step="1"
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
            v-on="inputListeners"
          />

          <div v-if="validations">
            <div
              v-if="
                validations.cardNumber === false ||
                validations.cardNumber === true
              "
              style="position: absolute; bottom: 0; right: 20px; z-index: -1"
            >
              <img
                v-if="$store.state.signup.cardType == 'american-express'"
                src="@/assets/cards/american-express.png"
              />
              <img
                v-else-if="$store.state.signup.cardType == 'aura'"
                src="@/assets/cards/aura.png"
              />
              <img
                v-else-if="$store.state.signup.cardType == 'diners'"
                src="@/assets/cards/diners.png"
              />
              <img
                v-else-if="$store.state.signup.cardType == 'discover'"
                src="@/assets/cards/discover.png"
              />
              <img
                v-else-if="$store.state.signup.cardType == 'elo'"
                src="@/assets/cards/elo.png"
              />
              <img
                v-else-if="$store.state.signup.cardType == 'hyper'"
                src="@/assets/cards/hyper.png"
              />
              <img
                v-else-if="$store.state.signup.cardType == 'jcb'"
                src="@/assets/cards/jcb.png"
              />
              <img
                v-else-if="$store.state.signup.cardType == 'mastercard'"
                src="@/assets/cards/mastercard.png"
              />
              <img
                v-else-if="$store.state.signup.cardType == 'visa'"
                src="@/assets/cards/visa.png"
              />
              <img v-else src="@/assets/cards/blank.png" />
            </div>
          </div>
          <div class="label">{{ label }}</div>
        </div>
        <div class="input-border"></div>
        <div class="input-border-animate"></div>
      </div>
    </div>
    <div class="text-field-validation" v-if="validations && validations.$error">
      <span v-if="!validations.required">Campo obrigatório</span>

      <span v-if="validations.masks === false && validations.required"
        >Formato inválido</span
      >

      <span
        v-if="
          validations.masks === true &&
          validations.brazilianDocument === false &&
          validations.required
        "
        >Documento inválido</span
      >

      <span v-if="validations.email === false && validations.required"
        >Use o formato de e-mail padrão, como email@exemplo.com.br</span
      >

      <span v-if="validations.emailIsUsed === false && validations.required"
        >O e-mail informado já está sendo utilizado.</span
      >

      <span v-if="validations.minValue === false && validations.required"
        >Quantidade informada deve ser no mínimo
        {{ validations.$params.minValue.min }}</span
      >

      <span v-if="validations.maxValue === false && validations.required"
        >Acima de 200 licenças, 
          <a target="_blank" 
            href="https://api.whatsapp.com/send?phone=+554333739307&text=Ol%C3%A1%21%20Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20o%20Task.">entre em contato</a>
      </span>

      <span v-if="validations.cardNumber === false && validations.required"
        >Numero de cartão inválido</span
      >
      <span v-if="validations.cardCVC === false && validations.required"
        >CVC inválido</span
      >
      <span
        v-if="validations.cardExpiringDate === false && validations.required"
        >Data inválida</span
      >
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
export default {
  directives: { mask },
  props: {
    mask: {
      type: Array,

      // default: () => []
    },

    label: String,
    value: String,
    validations: Object,
    type: String,
    step: String,
    maxlength: {
      type: String,
      default: "50",
    },
    minvalue: {
      type: String,
      default: "",
    },
    maxvalue: {
      type: String,
      default: "",
    },
    isUpper: {
      type: Boolean,
      default: false,
    },
    myValidate: {
      type: String,
      default: "",
    },
  },
  computed: {
    inputListeners: function () {
      var vm = this;
      return Object.assign({}, this.$listeners, {
        input: function (event) {
          vm.$emit("input", event.target.value);
        },
        blur: function (event) {
          vm.$emit("blur", event.target.value);
        },
      });
    },
  },
};
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.text-field-wrapper > .text-field-area {
  padding-top: 24px;
  padding-right: 15px;
}

.text-field-area {
  height: 40px;
  position: relative;
  vertical-align: top;
}

.text-field-holder {
  display: flex;
  position: relative;
  top: 14px;
}

.text-field {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-flex: 1;
  box-flex: 1;
  -webkit-flex-grow: 1;
  flex-grow: 1;
  -webkit-flex-shrink: 1;
  flex-shrink: 1;
  min-width: 0%;
  position: relative;
}

.text-field div.label {
  -webkit-transform-origin: bottom left;
  transform-origin: bottom left;
  -webkit-transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-property: color, bottom, transform;
  transition-property: color, bottom, transform;
  color: #25b686;
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  font-weight: 400;
  pointer-events: none;
  position: absolute;
  bottom: 3px;
  left: 0;
  width: 100%;
}

.text-field input {
  -webkit-box-flex: 1;
  box-flex: 1;
  -webkit-flex-grow: 1;
  flex-grow: 1;
  -webkit-flex-shrink: 1;
  flex-shrink: 1;
  background-color: transparent;
  border: none;
  display: block;
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  font-weight: 400;
  height: 24px;
  line-height: 24px;
  margin: 0;
  min-width: 0%;
  outline: none;
  padding: 0;
  z-index: 0;
}

.text-field input:focus {
  border-bottom: 1px solid #25b686;
}

.text-field input:not([disabled]):focus ~ div.label,
.text-field input[badinput="true"] ~ div.label,
.text-field.active div.label {
  transform: scale(0.75) translateY(-39px);
}

.text-field input:not([disabled]):focus ~ div.label {
  color: #25b686;
}

.input-border {
  background-color: rgba(0, 0, 0, 0.12);
  bottom: 0px;
  height: 1px;
  left: 0;
  margin: 0;
  padding: 0;
  position: absolute;
  width: 100%;
}

.input-border::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: -2px;
  left: 0;
  right: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0);
  pointer-events: none;
}

.input-border-animate {
  transform: scaleX(0);
  background-color: #4285f4;
  bottom: -2px;
  height: 2px;
  left: 0;
  margin: 0;
  padding: 0;
  position: absolute;
  width: 100%;
}

.input-border-animate.animate-action {
  animation: quantumWizPaperInputRemoveUnderline 0.3s
    cubic-bezier(0.4, 0, 0.2, 1);
}

.text-field-validation {
  span {
    color: #d50000;
    font-size: 12px;
  }
}
</style>
